import { useState, useCallback } from 'react';

function useToast() {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((message, variant = 'success', options = {}) => {
    setToast({ message, variant, ...options });
  }, []);

  const hideToast = useCallback(() => {
    setToast(null);
  }, []);

  return { toast, showToast, hideToast };
}

export default useToast;
